/**
 * 『商品情報』画面の受渡用VO
 *
 * @export KYMW1406InputModel
 * @class KYMW1406InputModel
 */
export class KYMW1406InputModel {
  /**
   * コマＩＤ
   */
  public komaID = Number(0);

  /**
   * 編集モード
   * 0:編集可、1:編集不可(ロック時)
   */
  public editMode = String('');

  /**
   * 選択コマのPコードリスト
   */
  public pcodeList: Array<any> = new Array<any>();

  /**
   * 注文商品区分
   * 01:通常注文商品　02：いつでも注文商品
   */
  public orderGoodsFlg = String('');

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();

  /**
   * 受注コード
   */
  public orderCode = '';

  /**
   * 媒体区分
   */
  public mediumType = '';
}
